// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";
import type { CheckoutSummary } from "../types";

type GetCheckoutSummary = {
  listingId: number,
  startDate: string,
  endDate: string,
  numberOfSpaces?: ?number,
  flexible?: boolean,
  vrm?: ?string,
  monthlyDuration?: ?string,
  monthlyApplicableDays?: boolean,
  evOptIn?: boolean,
  paymentMethodId?: number | string,
  quoteId?: ?string,
  isJp?: boolean
};

const checkoutSummary = ({
  listingId,
  startDate,
  endDate,
  numberOfSpaces = null,
  flexible = null,
  vrm = null,
  monthlyDuration = null,
  monthlyApplicableDays = null,
  evOptIn = false,
  paymentMethodId,
  quoteId = null,
  isJp = false,
  optionalExtras = {}
}: GetCheckoutSummary): ((
  apiInstance: AxiosInstance
) => AxiosPromise<CheckoutSummary>) => (apiInstance) => {
  debug("checkout.summary", {
    listingId,
    startDate,
    endDate,
    numberOfSpaces,
    flexible,
    vrm,
    monthlyDuration,
    monthlyApplicableDays,
    evOptIn,
    paymentMethodId,
    quoteId,
    optionalExtras
  });

  // The payment method ID could also be a string "applePay", if it is don't send it
  // Also zero is used as a falsey value so don't send that either
  const paymentSourceId =
    parseInt(paymentMethodId, 10) > 0 ? paymentMethodId : null;

  const postData = {
    listing_id: listingId,
    dates: [
      {
        start_date:
          typeof startDate === "string" ? startDate : startDate.format(),
        ...(endDate && {
          end_date: typeof endDate === "string" ? endDate : endDate.format()
        }),
        ...(monthlyDuration !== null && { duration: monthlyDuration })
      }
    ],
    enable_checkout_addons: optionalExtras,
    ...(monthlyDuration !== null &&
      monthlyApplicableDays !== null && {
        monthly_applicable_days: monthlyApplicableDays
      }),
    ...(isJp && { quote_id: quoteId }),
    ...(evOptIn && { ev_opt_in: evOptIn }),
    ...(isJp && { vrm }),
    ...(isJp && { payment_source_id: paymentSourceId }),
    ...(isJp && {
      enable_transaction_fee: true
    }),
    ...(!isJp && { flexible }),
    ...(!isJp && { number_of_spaces: numberOfSpaces })
  };

  return apiInstance.post(`/v5/checkout/summary`, postData);
};

export default checkoutSummary;
